import React, { useState, useCallback, Fragment, useEffect } from 'react';
import {Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider} from '@mui/material';
import client from '../common/client';
import {JSONTree} from 'react-json-tree'
import { useNotify } from 'react-admin';
import { useParams } from 'react-router-dom';

const BlockSketchJsonView = props => {
    const params = useParams()
    const [loading, setLoading] = useState(false);
    const [json, setJson] = useState({});

    useEffect(() => {
        setLoading(true)
        console.log(props)
        client.request_get(`/block_sketch/${params.id}`).then(res=>{
            setLoading(false)
            setJson(res)
        }).catch(e=>{
        })
    },[props.block_id])

    return (
        <Fragment>
            <div>{loading && <CircularProgress size={20} />}</div>
            <div>
                <JSONTree data={json} shouldExpandNode={(keyPath, data, level)=>true}/>
            </div>
        </Fragment>
    );
};

export default BlockSketchJsonView;
